export default "__VITE_ASSET__QHc8fpYK__"